module.exports = __webpack_public_path__ + "static/media/2.48e3b36f.jpg";